import React, { useEffect, useState } from "react";
import { get_file_from_s3 } from "../../utils";
import { imageDirectUrl, imageObjectKey } from "./constants";

// Presigned S3 URLs expire, so the key is exchanged for a fresh URL on mount
// rather than stored. Same precedence as handleDownload() in EditEmployee: a
// populated resourceName is used directly, otherwise presign the s3Document key.
const S3Image = ({ image, alt, className }) => {
  const [url, setUrl] = useState(() => imageDirectUrl(image));
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    let alive = true;
    const direct = imageDirectUrl(image);
    if (direct) {
      setUrl(direct);
      return undefined;
    }
    const key = imageObjectKey(image);
    if (!key) {
      setUrl("");
      return undefined;
    }
    setUrl("");
    setBroken(false);
    get_file_from_s3(key)
      .then((signed) => {
        if (!alive) return;
        if (signed) setUrl(signed);
        else setBroken(true);
      })
      .catch(() => {
        if (alive) setBroken(true);
      });
    return () => {
      alive = false;
    };
  }, [image]);

  if (broken) {
    return (
      <div className="flex items-center justify-center rounded-md bg-gray-50 px-4 py-6 text-xs text-gray-400">
        Image unavailable
      </div>
    );
  }

  if (!url) {
    return <div className="h-40 animate-pulse rounded-md bg-gray-100" />;
  }

  return (
    <img
      src={url}
      alt={alt || ""}
      onError={() => setBroken(true)}
      className={className || "max-h-80 w-full rounded-md object-cover"}
    />
  );
};

export default S3Image;
